export default "__VITE_ASSET__CTCTbXn7__"